export const labels = {
  es: {
    investmentsExperience: "¿Cuál es tu experiencia en inversiones?",
    hasOtherInvestmentAccountsBool: "¿Tiene otras cuentas de inversión?",
    otherInvestmentAccountName: "Nombre de la institución",
    otherInvestmentAccountYears: "Años de experiencia en la cuenta",
    isAffiliatedWithBroker:
      "¿Algún miembro de tu familia directa está afiliado o empleado por otro broker o dealer?",
    brokerName: "Nombre del broker",
    brokerEmployeeName: "Nombre del empleado",
    brokerEmployeeRelationship: "Relación",
  },
  en: {
    investmentsExperience: "¿How is your experience with investments?",
    hasOtherInvestmentAccountsBool: "Do you have other investment accounts?",
    otherInvestmentAccountName: "Name of the institution",
    otherInvestmentAccountYears: "Years of experience in the account",
    isAffiliatedWithBroker:
      "Is a member of your immediate family affiliated with or employed by another broker-dealer?",
    brokerName: "Broker dealer name",
    brokerEmployeeName: "Employee name",
    brokerEmployeeRelationship: "Relationship",
  },
};

export const title = {
  es: "Conocimiento y experiencia en inversiones",
  en: "Investment knowledge and experience",
};

export const texts = {
  es: { section1: "¿En cuáles instrumentos de inversión?", instrumentsRequired: "Seleccioná al menos un instrumento de inversión" },
  en: { section1: "In which investment instruments?", instrumentsRequired: "Select at least one investment instrument" },
};

export const placeholders = {
  es: {
    investmentsExperience: "Seleccioná una opcion",
    investmentToolKnowlage: "Conicimiento",
    investmentToolYears: "¿Desde cuándo?",
    otherInvestmentAccountName: "Ej. Bank of America",
    otherInvestmentAccountYears: "Ej. 10 años",
    brokerName: "Ej. Interactive Brokers",
    brokerEmployeeName: "Ej. Nicolás Echeverría",
    brokerEmployeeRelationship: "Ej. hijo, hija",
  },
  en: {
    investmentsExperience: "Select an option",
    investmentToolKnowlage: "Knowledge",
    investmentToolYears: "Since when?",
    otherInvestmentAccountName: "e.g. Bank of America",
    otherInvestmentAccountYears: "e.g. 10 years",
    brokerName: "e.g. Interactive Brokers",
    brokerEmployeeName: "e.g. John Doe",
    brokerEmployeeRelationship: "e.g. son, daughter",
  },
};
